export default __webpack_public_path__ + "static/media/6.c9e37dc6.jpg";